import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { newLoan } from "./NewLoan..reducer";
import { loanInfo } from "./loanInfo.reducer";
import { profile } from "./profile.reducer";
import { financialInfo } from "./financialInfo.reducer";
import { banner } from "./banner.reducer";
import  { accountDocumentsReducer } from "./document.reducer";
import  { configuration } from "./configuration.reducer";
import { guest } from "./guest.reducer";

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  newLoan, 
  loanInfo, 
  profile,
  financialInfo,
  banner,
  documents: accountDocumentsReducer,
  configuration,
  guest
});

export default rootReducer;